import { Component, OnInit } from '@angular/core';
import { SpinnerService } from '../../../../services/spinner.service';

@Component({
  selector: 'app-loader-spinner',
  templateUrl: './loader-spinner.component.html',
  styleUrls: ['./loader-spinner.component.css']
})
export class LoaderSpinnerComponent implements OnInit {

  showSpinner: boolean = false;

  constructor(private spinner: SpinnerService) {

  }

  ngOnInit(): void {
    this.spinner.showSpinnerValue.subscribe(()=>{
      this.showSpinner = this.spinner.showSpinner;
    });
  }

}
